
export default {
    inject: ['EventBus', 'PIXIWrapper'],

    props: {
        content: {
            type: String,
            default: ''
        },
        fontSize: {
            type: Number,
            default: 20
        },
        color: {
            type: Number,
            default: 0xFFFFFF
        },
        align: {
            type: String,
            default: 'center',
            validator: (val) => ['left', 'center', 'right'].includes(val)
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        alpha: {
            type: Number,
            default: 1
        },
        anchorX: {
            type: Number,
            default: 0
        },
        anchorY: {
            type: Number,
            default: 0
        },
        width: {
            type: Number
        },
        zIndex: {
            type: Number
        },
        angle: {
            type: Number
        },
        interactive: {
            type: Boolean,
            default: true
        },
        pointer: {
            type: Boolean,
            default: false
        },
        animation: {
            type: String,
            default: ''
        },
        animationDelay: {
            type: Number,
            default: 0
        }
    },

    data () {
        return {
            text: null,
            container: null,
            animationFunction: null,
            animationDelayTimeout: null
        };
    },

    watch: {
        alpha () {
            this.text.alpha = this.alpha;
        },
        content () {
            this.text.text = this.content;
        },
        x () {
            this.text.x = this.x;
        },
        y () {
            this.text.y = this.y;
        },
        color () {
            this.text.style.fill = this.color;
        },
        pointer () {
            this.text.cursor = this.pointer ? 'pointer' : 'default';
        },
        animation () {
            if (this.animation !== '') {
                this.addAnimation();
            }

            if (this.animation === '' && this.animationFunction) {
                this.PIXIWrapper.AnimationManager.remove(this.animationFunction);
            }
        }
    },

    created () {
        this.container = this.$game.getParentPIXIContainer(this);
        this.PIXIWrapper.LoaderManager.add(this, this.draw);
    },

    destroyed () {
        if (this.text !== null && !this.text._destroyed) {
            this.text.destroy(true);
        }
    },

    methods: {
        /**
         * Draw the container.
         */
        draw () {
            this.text = new this.PIXIWrapper.PIXI.Text(this.content, {
                fontFamily: 'Open Sans',
                fontSize: this.fontSize * 1.5,
                fill: this.color,
                align: this.align,
                wordWrap: true,
                wordWrapWidth: this.width * 1.5
            });

            this.text.scale.x = 0.66666;
            this.text.scale.y = 0.66666;

            this.text.x = this.x;
            this.text.y = this.y;

            this.text.alpha = this.alpha;

            if (this.zIndex !== undefined) {
                this.text.zIndex = this.zIndex;
            }

            if (this.angle !== undefined) {
                this.text.angle = this.angle;
            }

            if (this.pointer) {
                this.text.cursor = 'pointer';
            }

            if (this.animation !== '') {
                this.addAnimation();
            }

            if (this.interactive) {
                this.defineEvents();
            }

            this.text.anchor.set(this.anchorX, this.anchorY);

            // Add the text to the parent container or the root app stage.
            if (this.container) {
                this.container.addChild(this.text);
            } else {
                this.PIXIWrapper.app.stage.addChild(this.text);
            }
        },

        /**
         * Define all pixi events that should be emitted ($emit) to the parent component.
         * Only events that are used in parent component ($listeners) will be attached.
         */
        defineEvents () {
            let eventList = [
                'added',
                'click',
                'mousedown',
                'mousemove',
                'mouseout',
                'mouseover',
                'mouseup',
                'mouseupoutside',
                'pointercancel',
                'pointerdown',
                'pointermove',
                'pointerout',
                'pointerover',
                'pointertap',
                'pointerup',
                'pointerupoutside',
                'removed',
                'rightclick',
                'rightdown',
                'rightup',
                'rightupoutside',
                'tap',
                'touchcancel',
                'touchend',
                'touchendoutside',
                'touchmove',
                'touchstart'
            ];

            this.text.interactive = true;

            eventList
                .filter(eventName => Object.keys(this.$listeners).includes(eventName))
                .forEach(eventName => {
                    this.text.on(eventName, (event) => {
                        this.$emit(eventName, {
                            element: this.text,
                            event,
                            AnimationManager: this.PIXIWrapper.AnimationManager
                        });
                    });
                });
        },

        /**
         * Add text animation.
         */
        addAnimation () {
            this.animationDelayTimeout = setTimeout(() => {
                if (this.animation === 'pulse') {
                    let scaleUp = true;
                    let scaleValue = 0.002;

                    this.animationFunction = (delta) => {
                        this.text.scale.x += scaleUp ? scaleValue : -scaleValue;
                        this.text.scale.y += scaleUp ? scaleValue : -scaleValue;

                        if (this.text.scale.x >= 0.69) {
                            scaleUp = false;
                        } else if (this.text.scale.x <= 0.66666) {
                            scaleUp = true;
                        }
                    };

                    this.PIXIWrapper.AnimationManager.add(this.animationFunction);
                }
            }, this.$game.delay * this.animationDelay);
        }
    },

    render: (h) => h()
};
